var map = {
	"./applepay.jpg": 71288,
	"./mastercard.jpg": 65086,
	"./paypal.jpg": 67367,
	"./stripe.svg": 34061,
	"./stripe_sm.webp": 91440,
	"./visa.jpg": 37617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33110;